import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Header, Icon, Segment } from "semantic-ui-react";
import { getAllSafePlaceQR, qrSearch } from "services/safeplace";
import { getAllPreregisterQR, qrPreregister } from "services/preregister";
import { getAllCampaignQR, qrSearchCampaign } from "services/campaign";
import moment from "moment";
import debounce from "debounce-promise";
import AsyncSelect from "react-select/async";

import QRPatientCard from "./components/QRPatientCard";

const styles = {
	blocWhite: {
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		backgroundColor: "#fff",
		padding: 20,
		borderRadius: "0 0 4px 4px",
		minHeight: "100%",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
		color: "white",
	},
};

class SafePlaceQR extends Component {
	constructor(props) {
		super(props);
		this.state = {
			safeplaceQRlist: null,
			preregisterQRlist: null,
			campaignQRlist: null,
		};
	}

	searchInList = async (search) => {
		this.props.getAllSafePlaceQR(search).then(() => this.setState({ safeplaceQRlist: this.props.safeplaceQR.list.data }));
		this.props.getAllPreregisterQR(search).then(() => this.setState({ preregisterQRlist: this.props.preregisterQR.list.data }));
		this.props.getAllCampaignQR(search).then(() => this.setState({ campaignQRlist: this.props.campaignQR.list.data }));
	};

	safeplaceOptions = () => {
		const { safeplaceQR } = this.props;
		if (safeplaceQR && safeplaceQR.list && safeplaceQR.list.data && safeplaceQR.list.data.length > 0)
			return safeplaceQR.list.data.map((sf) => ({
				label: `${sf.gender === "male" ? "(M)" : "(F)"} ${sf.birth_name} ${sf.last_name} ${sf.first_name} -${sf.matricule} ${moment(
					sf.birth_date
				).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)}`,
				value: sf.qr_code,
			}));
		return [];
	};

	filterSafeplace = debounce((searchTerm) => {
		return new Promise((resolve, reject) => {
			this.searchInList(searchTerm);
		});
	}, 500);

	render() {
		return (
			<Grid textAlign="left" style={{ height: "100vh" }} verticalAlign="top">
				<Grid.Column style={{ maxWidth: 1550, paddingTop: 40, height: "93vh" }}>
					<Header as="h2" color="teal" textAlign="center" style={{ backgroundColor: "rgb(0, 147, 128)" }}></Header>
					<div style={styles.blocHeader}>
						<h3>Liste des patients avec un QR code en attente </h3>
					</div>
					<div style={styles.blocWhite}>
						<AsyncSelect
							onChange={(option) => {
								if (option) this.searchInList(option.value);
							}}
							defaultOptions={this.safeplaceOptions()}
							placeholder="Rechercher un patient"
							loadOptions={(value) => this.filterSafeplace(value)}
							noOptionsMessage={() => "Aucun résultat"}
							loadingMessage={() => "Chargement..."}
							isClearable
						/>

						<div style={{ margin: 40 }}>
							{this.state.preregisterQRlist && this.state.preregisterQRlist.length >= 0 && (
								<div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-around" }}>
									<Header as="h2">
										<Icon name="tasks" />
										<Header.Content>
											CHECK-IN
											<Header.Subheader>Retrouvez ici la liste des patients pré-inscrits correspondant à votre recherche</Header.Subheader>
										</Header.Content>
									</Header>
									{this.state.preregisterQRlist.length === 0 && (
										<Segment placeholder style={{ margin: "25px 0", width: "100%" }}>
											<Header icon>
												<Icon name="file excel outline" />
												Aucune pré-inscription ne correspond à votre recherche.
											</Header>
										</Segment>
									)}
									{this.state.preregisterQRlist.length > 0 && (
										<Segment style={{ margin: "25px 0", width: "100%", display: "flex", flexWrap: "wrap", justifyContent: "space-around" }}>
											{this.state.preregisterQRlist.map((item) => (
												<QRPatientCard key={`qrcard-${item.qr_code}`} el={item} qrSearch={this.props.qrPreregister} />
											))}
										</Segment>
									)}
								</div>
							)}
							{this.state.campaignQRlist && this.state.campaignQRlist.length >= 0 && (
								<div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-around" }}>
									<Header as="h2">
										<Icon name="calendar alternate outline" />
										<Header.Content>
											Campagnes de prélèvement
											<Header.Subheader>Retrouvez ici la liste des patients inscrits pour une campagne de prélèvement</Header.Subheader>
										</Header.Content>
									</Header>
									{this.state.campaignQRlist.length === 0 && (
										<Segment placeholder style={{ margin: "25px 0", width: "100%" }}>
											<Header icon>
												<Icon name="address card outline" />
												Aucun patient inscrit pour une campagne de prélèvement ne correspond à votre recherche.
											</Header>
										</Segment>
									)}
									{this.state.campaignQRlist.length > 0 && (
										<Segment style={{ margin: "25px 0", width: "100%", display: "flex", flexWrap: "wrap", justifyContent: "space-around" }}>
											{this.state.campaignQRlist.map((item) => (
												<QRPatientCard key={`qrcard-${item.qr_code}`} el={item} qrSearch={this.props.qrSearchCampaign} />
											))}
										</Segment>
									)}
								</div>
							)}
						</div>
					</div>
				</Grid.Column>
			</Grid>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		safeplaceQR: state.safeplace,
		preregisterQR: state.preregister,
		campaignQR: state.campaigns,
	};
};

const mapDispatchToProps = {
	getAllSafePlaceQR,
	qrSearch,
	getAllPreregisterQR,
	qrPreregister,
	getAllCampaignQR,
	qrSearchCampaign,
};

export default connect(mapStateToProps, mapDispatchToProps)(SafePlaceQR);
